/** Temporary boundary adapter for the imported 2026 source snapshot. */
export function repairLegacyEncoding(value: string): string {
  if (!/[ÃÄÅâ]/.test(value)) return value;
  try {
    const bytes = Uint8Array.from(value, (character) => character.charCodeAt(0) & 0xff);
    return new TextDecoder("utf-8", { fatal: true }).decode(bytes);
  } catch {
    return value;
  }
}
